import React from 'react';

import { useTranslation } from 'react-i18next';
const Footer = () => {
  const { t } = useTranslation();
  const version = process.env.REACT_APP_VERSION;
  return (
    <div data-include="component-footer">
    <footer>
      <div className="page-container">
        <span className="txt-version">{t('footer.version')} {version}</span>
      </div>
    </footer></div>
  );
};

export default Footer;
